import type { CalEvent } from "../types";
import { useLoadedOnce } from "./useLoadedOnce";

/** Repeat labels read this session, by series ("Repeats weekly"). */
const cache = new Map<string, string | null>();

/** The repeat label of each series on the day, by series id; left out until read, or if the pattern is unknown. */
export function useRepeatLabels(
  load: (seriesMasterId: string) => Promise<string | null>,
  events: readonly CalEvent[],
): ReadonlyMap<string, string> {
  const series = [...new Set(events.flatMap((e) => (e.seriesMasterId ? [e.seriesMasterId] : [])))];
  return useLoadedOnce(cache, series.map((id) => ({ key: id, id, load: () => load(id) })), "load-row-recurrence");
}
